import * as React from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import _ from './../../utils/lodash';
var SearchField = function (_a) {
    var onSearch = _a.onSearch, placeholder = _a.placeholder, value = _a.value, debounceTimer = _a.debounceTimer, otherValues = _a.otherValues, variant = _a.variant, size = _a.size, sx = _a.sx, showSearchIcon = _a.showSearchIcon;
    var _b = React.useState(value || ''), searchTextValue = _b[0], setSearchTextValue = _b[1];
    var debounceOnValueChange = React.useCallback(_.debounce(onSearch, debounceTimer), [onSearch, debounceTimer]);
    var handleOnChange = function (e) {
        var val = e.target.value;
        setSearchTextValue(val);
        if (val.length === 0) {
            debounceOnValueChange.cancel();
            onSearch('', otherValues);
        }
        else if (val.length === 1) {
            debounceOnValueChange.cancel();
        }
        else {
            debounceOnValueChange(val, otherValues);
        }
    };
    var handleClear = function () {
        debounceOnValueChange.cancel();
        setSearchTextValue('');
        onSearch('', otherValues);
    };
    React.useEffect(function () {
        setSearchTextValue(value || '');
    }, [value]);
    React.useEffect(function () {
        return function () {
            debounceOnValueChange.cancel();
        };
    }, [debounceOnValueChange]);
    return (React.createElement(TextField, { className: 'search_feild', placeholder: placeholder, value: searchTextValue, disabled: Boolean(otherValues === null || otherValues === void 0 ? void 0 : otherValues.disabled), onChange: handleOnChange, InputProps: {
            startAdornment: showSearchIcon ? (React.createElement(InputAdornment, { position: "start" },
                React.createElement(SearchIcon, { fontSize: "small", sx: { color: 'text.secondary' } }))) : undefined,
            endAdornment: searchTextValue ? (React.createElement(InputAdornment, { position: "end" },
                React.createElement(IconButton, { size: "small", onClick: handleClear, sx: { p: 0.25 } },
                    React.createElement(CloseIcon, { fontSize: "small" })))) : null,
        }, inputProps: { maxLength: 50 }, fullWidth: true, variant: variant || 'standard', size: size, sx: sx }));
};
export default React.memo(SearchField);
